module.exports = function() {
  return new Worker(__webpack_public_path__ + "9a4b39cb5140059b777a.worker.js");
};